module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.ocultarItem) ? _c('li', {
    class: _vm.getType
  }, [(_vm.router && _vm.router.name) ? [_c('router-link', {
    attrs: {
      "to": _vm.router
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.badge),
      expression: "badge"
    }],
    staticClass: "pull-right-container"
  }, [_c('small', {
    staticClass: "label pull-right",
    class: [_vm.badge.type === 'String' ? 'bg-green' : 'label-primary']
  }, [_vm._v(_vm._s(_vm.badge.data))])])])] : [_vm._v("\n    " + _vm._s(_vm.isHeader ? _vm.name : '') + "\n    "), (!_vm.isHeader) ? _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [(_vm.badge && _vm.badge.data) ? _c('small', {
    staticClass: "label pull-right",
    class: [_vm.badge.type === 'String' ? 'bg-green' : 'label-primary']
  }, [_vm._v(_vm._s(_vm.badge.data))]) : _c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])]) : _vm._e(), _vm._v(" "), (_vm.filterItems.length > 0) ? _c('ul', {
    staticClass: "treeview-menu"
  }, _vm._l((_vm.filterItems), function(item, index) {
    return (item.router && item.router.name) ? _c('router-link', {
      key: index,
      attrs: {
        "tag": "li",
        "data": item,
        "to": item.router
      }
    }, [(_vm.exibeSubMenuGrupoUsuario(item)) ? _c('a', [_c('i', {
      class: item.icon
    }), _vm._v(" " + _vm._s(item.name) + "\n        ")]) : _vm._e()]) : _vm._e()
  }), 1) : _vm._e()]], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39e54e47!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VASlideItem.vue
// module id = 975
// module chunks = 1